



































































import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class RightSidebar extends Vue {
  @Prop({ type: Boolean, default: false }) darkenBackground!: boolean;

  mounted() {
    document.body.style.overflowY = 'hidden';
  }
  beforeDestroy() {
    document.body.style.overflowY = '';
  }
}
